module.exports = __webpack_public_path__ + "static/media/Simulator Screen Shot - iPhone 13 Pro - 2022-03-14 at 00.47.48.67e09741.png";